.CommandPaletteInput {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-bottom: 1px solid var(--soniq-t--global--border--color--card--default);
}

.CommandPaletteInput__icon {
    flex-shrink: 0;
    color: var(--soniq-t--global--text--color--hint--default);
    font-size: 18px;
    display: flex;
    align-items: center;
}

.CommandPaletteInput__input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    font-size: 16px;
    font-family: var(--soniq-t--global--font--family--sans);
    color: var(--soniq-t--global--text--color--primary--default);
    min-width: 0;

    &::placeholder {
        color: var(--soniq-t--global--text--color--hint--default);
    }
}

.CommandPaletteInput__shortcut {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;
}
